import { range } from './general';

const MAX_NON_INTRO_SECTIONS = 100;

function _getTranslationKeys(translations) {
    return range(MAX_NON_INTRO_SECTIONS).reduce((arr, item, index) => {
        const translationIndex = index + 1;
        const title = `longContentTitle${translationIndex}`;
        const description = `longContentDescription${translationIndex}`;
        const shortcut = `longContentShortcut${translationIndex}`;

        if (!translations[title] || !translations[description] || !translations[shortcut]) {
            return arr;
        }

        return [
            ...arr,
            {
                title,
                description,
                shortcut,
            },
        ];
    }, []);
}

function extractTemplate(translations) {
    if (!translations) {
        return undefined;
    }

    let template = {
        sections: _getTranslationKeys(translations).map(({ title, description, shortcut }) => ({
            title,
            description,
            id: shortcut,
        })),
        shortcuts: _getTranslationKeys(translations).map(({ shortcut }) => ({
            text: shortcut,
            id: shortcut,
        })),
    };

    if (translations.longContentDescription0) {
        template = {
            intro: 'longContentDescription0',
            ...template,
        };
    }

    return template;
}

function shortDaysOfWeek(days, locale) {
    const formatter = new Intl.DateTimeFormat(locale, { weekday: 'short' });
    return days.map(day => formatter.format(new Date(0, 0, day)));
}

export { extractTemplate, shortDaysOfWeek };
export default { extractTemplate };
